import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { map } from 'lodash';
import { Button } from 'react-bootstrap';
import UserTable from '../../components/UserTable/UserTable';
import NumberDisplay from '../../../../components/number-display';
import Pusher from '../../../../components/pusher';

// Import Actions
import {
  fetchOrganizationUsers,
  requestSyncUsers,
  requestInviteOrganizationUsers,
  updateOrganizationUser,
} from '../../SetupActions';

// Import Selectors
import { getOrganizationUsers } from '../../SetupReducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import UserTypeSettings from '../UserTypePage/UserTypeSettings';

class UserPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: null,
      selectedIds: [],
      invitings: false,
      currentWelcomeUser: null,
    };
    this.syncUsers = this.syncUsers.bind(this);
    this.requestSync = this.requestSync.bind(this);
    this.checkboxSelection = this.checkboxSelection.bind(this);
    this.handleToggleSelect = this.handleToggleSelect.bind(this);
    this.sendEmails = this.sendEmails.bind(this);
    this.handleOrganizationSendInvitationEmail = this.handleOrganizationSendInvitationEmail.bind(this);
    this.handleOrganizationSendInvitationEmailDone = this.handleOrganizationSendInvitationEmailDone.bind(this);
  }

  componentDidMount() {
    // this.syncUsers();
  }

  syncUsers(params) {
    const { userCurrentOrganization } = this.props;
    return this.props.dispatch(fetchOrganizationUsers(userCurrentOrganization._id, params));
  }

  checkboxSelection({ data }) {
    return data && data.last_activity === null && (!data.logs || data.logs === 0) && !data.pending_invite;
  }

  handleToggleSelect(users) {
    this.setState({ selectedIds: map(users, '_id') });
  }

  handleOrganizationSendInvitationEmail(user) {
    this.props.dispatch(updateOrganizationUser(user));
    this.setState({ currentWelcomeUser: user });
  }

  handleOrganizationSendInvitationEmailDone() {
    this.context.addNotification((
      <div>
        All welcome emails have been sent!
      </div>
    ));
    this.setState({ currentWelcomeUser: null });
  }

  sendEmails() {
    if (!this.state.invitings) {
      const { userCurrentOrganization } = this.props;
      const { selectedIds } = this.state;
      this.setState({ invitings: true, selectedIds: [] }, () => {
        this.props.dispatch(requestInviteOrganizationUsers(userCurrentOrganization._id, selectedIds))
          .then(
            () => {
              this.setState({ invitings: false });
            },
            () => {
              this.setState({ invitings: false });
            },
          );
      });
    }
  }

  requestSync() {
    const { userCurrentOrganization } = this.props;
    const { location } = this.props;
    const { pathname } = location;
    const query = queryString.parse(location.search);
    this.context.router.history.push({ pathname, query });
    this.props.dispatch(requestSyncUsers(userCurrentOrganization._id, query))
      .catch((error) => {
        const el = <div>Users failed to sync<br />{error.data.message}</div>;
        this.context.addNotification(el, { type: 'error', autoClose: true });
      });
  }

  renderSyncButton() {
    const { userCurrentOrganization } = this.props;
    const syncing = false;
    if (userCurrentOrganization.sync_type === 'summary') {
      return null;
    }
    return (
      <div>
        <span>
          {!syncing && <button type="button" className="btn btn-sm btn-default" onClick={this.requestSync}><Fa name="refresh" /> Sync Users</button>}
          {syncing && <button type="button" disabled={syncing} className="btn btn-sm btn-default"><Fa name="refresh" spin /> Syncing</button>}
        </span>
      </div>
    );
  }

  renderMailLink() {
    const { selectedIds, invitings } = this.state;
    const hasSelected = selectedIds.length > 0;
    return (
      <span>
        {hasSelected &&
          <Button bsStyle="primary" disabled={invitings} onClick={this.sendEmails}>
            <Fa name={invitings ? 'spinner' : 'envelope'} spin={invitings} /> Send Welcome Emails (<NumberDisplay value={selectedIds.length} precision={0} />)
          </Button>
        }
        {!hasSelected &&
          <Button bsStyle="primary" disabled>
            <Fa name="envelope" /> Send Welcome Emails
          </Button>
        }
        &nbsp;&nbsp;&nbsp;
      </span>
    );
  }

  render() {
    const {
      selectedIds,
      currentWelcomeUser,
    } = this.state;
    const { userCurrentOrganization } = this.props;
    const isDemo = userCurrentOrganization && userCurrentOrganization.is_demo;
    const orgId = userCurrentOrganization._id;
    return (
      <div className="container">
        <Helmet title="Manage Users" />
        <Pusher key={`${orgId}-organizationInvitationEmail`} event="organizationSendInvitationEmail" handler={this.handleOrganizationSendInvitationEmail} />
        <Pusher key={`${orgId}-organizationInvitationEmailDone`} event="organizationSendInvitationEmailDone" handler={this.handleOrganizationSendInvitationEmailDone} />
        <div className="clearfix">
          <div className="pull-right">
            {!isDemo && this.renderSyncButton()}
          </div>
          {!isDemo &&
            <div>
              <UserTypeSettings isModal />
            </div>
          }
          
        </div>
        <p />
        {!isDemo &&
          <div>
            <UserTable
              key={userCurrentOrganization._id}
              selectable
              showOrganizationDetailColumn={false}
              showEmailColumn={false}
              organization={userCurrentOrganization}
              onAdd={() => {}}
              toggleSelect={this.handleToggleSelect}
              topControl={this.renderMailLink()}
              selectedIds={selectedIds}
              checkboxSelection={this.checkboxSelection}
              fetchAction={this.syncUsers}
              flashRow={currentWelcomeUser}
            />
          </div>}
        {isDemo &&
          <div className="alert alert-warning">
            This is a demo organization. You cannot add any user to it.
          </div>}
      </div>
    );
  }
}

// SetupPage.need = [() => { return fetchStages(); }];

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    users: getOrganizationUsers(state),
    userCurrentOrganization: getUserCurrentOrganization(state),
  };
}

UserPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  users: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  userCurrentOrganization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};

UserPage.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(UserPage);
